import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apply as interceptorApply } from '@/apis/config/interceptor'

function create(config?: AxiosRequestConfig) {
  const instance = Axios.create(config)
  interceptorApply(instance)
  return instance
}

export const v1 = create({
  baseURL: '/api/v1/operating',
})

export const v2 = create({
  baseURL: '/api/v2',
})

export const auth = create({
  baseURL: '/api/auth',
  headers: {
    'Content-Type': 'application/json',
  }
})

export const service = create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
})

export const base = create({
  baseURL: '',
})

export const bffTenth = create({
  baseURL: '/tenth',
})

export const tenth = create({
  baseURL: `https://${process.env.VUE_APP_TENTH_UPLOAD_HOST}`,
})
